export default "__VITE_ASSET__Dt6Z6vvN__"